<style>
.mat-toolbar.mat-primary {
  background:#373737;
  color: #fff;
}
</style>
<mat-toolbar color="primary">
  <img routerLink="" style="cursor:pointer" width="125" src="../assets/Valor Preclusion title logo.jpg"/>
  <a style="align-content: center; margin-left:50px; float:right" mat-button color="secondary" routerLink="/characters/">Characters</a>
  <a style="align-content: center; margin-left:50px; float:right" mat-button color="secondary" routerLink="/comic/0/page/1">Comic</a>
  <a style="align-content: center; margin-left:50px; float:right" mat-button color="secondary" routerLink="/about">About</a>
  <a style="align-content: center; margin-left:50px; float:right" mat-button color="secondary" href="https://vpcomic.threadless.com/">Store</a>
</mat-toolbar>
<div class="content">
  <router-outlet></router-outlet>
</div>